









import TableCell from './TableCell.vue'

export default {
  components: {
    TableCell
  },
  props: {
    suggestedBaseCost: { type: Number, default: 0 },
    hSpan: { type: Number, default: 4 }
  }
}
